import React from "react";
import { Box, HStack, Link, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

// Small, unobtrusive site-wide footer. Rendered once in App.js so it
// appears beneath every route without each page needing to opt in.
const Footer = () => {
  const { language } = useLanguage();
  const copy = {
    en: { terms: "Terms", privacy: "Privacy", support: "Support" },
    fr: { terms: "Conditions", privacy: "Confidentialité", support: "Soutien" },
  };
  const t = copy[language] || copy.en;
  const year = new Date().getFullYear();

  return (
    <Box
      as="footer"
      borderTopWidth="1px"
      borderColor="gray.200"
      bg="gray.50"
      color="gray.600"
      py={3}
      px={4}
      mt={8}
      fontSize="xs"
    >
      <HStack
        maxW="6xl"
        mx="auto"
        justify="space-between"
        align="center"
        spacing={4}
        flexWrap="wrap"
      >
        <Text>© {year} Coupal</Text>
        <HStack spacing={4}>
          <Link as={RouterLink} to="/terms" _hover={{ color: "green.600" }}>
            {t.terms}
          </Link>
          <Link as={RouterLink} to="/privacy" _hover={{ color: "green.600" }}>
            {t.privacy}
          </Link>
          <Link
            href="mailto:support@coupal.app"
            _hover={{ color: "green.600" }}
          >
            {t.support}: support@coupal.app
          </Link>
        </HStack>
      </HStack>
    </Box>
  );
};

export default Footer;
